import SideBar from "./mini/SideBar";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { Outlet } from "react-router-dom";
import { toggleSidebar } from "../redux/features/sidebarSlice";


export default function Dashboard() {

    const dispatch = useDispatch()
    const sidebar = useSelector((state) => state.sidebar.value)
    window.onclick = function(event) {

        const modal = document.querySelector("#side-modal")

        if (event.target === modal) {
            dispatch(toggleSidebar(!sidebar))
        }
    }

    return (
        <section className="">
            <div className={ sidebar ? "sidebar p-3 pt-4 pb-0" : "sidebar-inner d-md-block d-none p-3 pt-4 pb-0"}>
                <SideBar />
            </div>
            { sidebar ? <div className="modal d-block" id="side-modal"></div> : '' }
            <main className="p-sm-5 p-3 pt-4 pb-0 dash-main-content">
                <Outlet />
            </main>
        </section>
    )
}